<section
  *ngIf="productDetailsLoaded"
  class="padder"
  fxLayout="row"
  fxLayoutAlign="center center"
>
  <mat-card class="flex-1400px flex-100-lt-lg">
    <div fxLayout="row" class="breadcrumbs">
      <app-breadcrumb [breadcrumbs]="breadCrumbs"></app-breadcrumb>
    </div>
    <mat-card-content>
      <div
        fxLayout="row"
        fxLayout.lt-lg="row wrap"
        fxLayoutAlign="left right"
        fxLayoutGap="20%"
      >
        <mat-card fxFlex="50%" fxFlex.lt-lg="100%">
          <mat-card-header>
            <mat-card-title class="details-title">
              <div class="div-2">
                <h1>{{ product.vendor }} {{ product.name }}</h1>
              </div>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content
            fxLayout="column"
            fxLayoutAlign="left right"
            fxLayoutGap="1%"
          >
            <div fxLayout="row">
              <span fxFlex="40%"
                >{{ 'product_info.vendor.label' | translate }}:</span
              >
              <span fxFlex="60%">{{ product.vendor }}</span>
            </div>
            <div fxLayout="row">
              <span fxFlex="40%"
                >{{ 'product_info.availability.label' | translate }}:</span
              >
              <span fxFlex="60%">{{ roundedAvailability }}</span>
            </div>

            <div fxLayout="row" *ngFor="let info of product.info">
              <span *ngIf="info.value !== 0" fxFlex="40%"
                >{{ 'product_info.' + info.key + '.label' | translate }}:</span
              >
              <span *ngIf="info.value !== 0" fxFlex="60%"
                >{{ getProductInfoValue(info.key, info.value) | async }}</span
              >
            </div>
          </mat-card-content>
        </mat-card>
        <div fxLayout="column" fxFlex="50%" fxFlex.lt-lg="100%">
          <app-add-cart
            [product]="product"
            [availability]="availability"
          ></app-add-cart>
          <div class="app-add-project-item-container">
            <app-add-project-item
              *ngIf="loggedIn | async"
              [productItem]="product"
              [projects]="projects"
              [(open)]="isProjectInputOpen"
              (click)="openProjectList($event)"
            ></app-add-project-item>
          </div>
        </div>
      </div>

      <div class="info-area">
        <div fxLayout="100%">
          <span
            ><b>{{ 'product.info.title1' | translate }}:</b> {{
            'product.info.misc1' | translate }}</span
          >
        </div>
        <div fxLayout="100%">
          <span
            ><b>{{ 'product.info.title2' | translate }}:</b> {{
            'product.info.misc2' | translate }}</span
          >
        </div>
      </div>

      <div *ngIf="product.description">
        <h2>{{ 'product.description' | translate }}:</h2>
        <div [innerHTML]="product.description"></div>
      </div>

      <div *ngIf="product.contains && product.contains.length">
        <h2>{{ 'product.contained_products' | translate }}:</h2>
        <ul class="no-bullets">
          <li *ngFor="let item of product.contains" class="padding-left">
            <a
              *ngIf="item.id && item.available; else noLink"
              [routerLink]="'../../' + item.id + '/' + urlName(item)"
            >
              {{ item.label }}
            </a>
            <ng-template #noLink>{{ item.label }}</ng-template>
          </li>
        </ul>
      </div>

      <div *ngIf="product.containedIn && product.containedIn.length">
        <h2>{{ 'product.contained_in_bundles' | translate }}:</h2>
        <ul class="no-bullets">
          <li *ngFor="let item of product.containedIn" class="padding-left">
            <a [routerLink]="'../../' + item.id + '/' + urlName(item)">
              {{item.name}}
            </a>
          </li>
        </ul>
      </div>

      <div fxLayout="100%">
        <h2 translate="">{{ 'product.related_item_label' | translate }}:</h2>
      </div>
      <app-product-related-item
        [white_bg]="true"
        fxLayout="column"
        fxLayoutAlign="center stretch"
      >
      </app-product-related-item>
    </mat-card-content>
  </mat-card>
</section>

<section
  *ngIf="!productDetailsLoaded"
  class="padder"
  fxLayout="row"
  fxLayoutAlign="center center"
>
  <app-page-loader></app-page-loader>
</section>
